import ReactDOM from 'react-dom/client';
// eslint-disable-next-line no-restricted-imports
import { QueryClient, QueryClientProvider } from 'react-query';
import { RouterProvider } from 'react-router-dom';
import './index.css';
//@ts-expect-error js file
import { router } from './routes/router';
import { ThemeProvider } from './context/ColorThemeContext';
import ConfirmationDialogContextProvider from './context/ConfirmationDialogContext';
import TemplateGalleryProvider from './context/TemplateGalleryContext';
import { initializeClarity } from './utils/clarity.utils';
import { initializeSentry } from './utils/sentry.utils';

initializeSentry();
initializeClarity();

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <ConfirmationDialogContextProvider id="confirmation-dialog">
        <TemplateGalleryProvider>
          <RouterProvider router={router} />
        </TemplateGalleryProvider>
      </ConfirmationDialogContextProvider>
    </ThemeProvider>
  </QueryClientProvider>,
);
